module.exports = __webpack_public_path__ + "img/202002.74d014c6.png";